import { h, type View } from '../components/dom.js';
import type { SessionController } from '../../session/controller.js';

export function createEspacioView(controller: SessionController): View {
  const abort = new AbortController();
  const base = controller.getServerBase().replace(/\/+$/, '');
  const url = `${base}/espacio/`;
  const status = h('p', { class: 'muted', role: 'status' }, ['Abriendo tu Espacio…']);
  const state = h('div', { class: 'espacio-state' }, [status]);
  const back = h('a', { class: 'espacio-back', href: '#/hoy' });
  back.innerHTML = '<span>‹ Volver a ASIS</span>';
  const el = h('section', { class: 'espacio-view', 'aria-label': 'Espacio' }, [back, state]);

  function failed(): void {
    if (abort.signal.aborted) return;
    const desktop = window.asisDesktop?.openCreateApps;
    const open = h('a', { class: 'btn ghost', href: url, target: '_blank', rel: 'noopener' }, ['Abrir en el navegador']);
    if (desktop) open.addEventListener('click', event => { event.preventDefault(); void desktop(url); });
    status.textContent = 'No se ha podido abrir tu Espacio aquí.';
    state.append(open);
  }

  async function enter(): Promise<void> {
    // The session belongs to ASIS: the space never asks for the password again.
    const token = controller.usesBrowserSession() ? null : controller.getToken();
    const response = await fetch(`${base}/espacio/auth/exchange`, {
      method: 'POST', credentials: 'include', cache: 'no-store', signal: abort.signal,
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
    });
    if (!response.ok) { failed(); return; }
    const frame = h('iframe', { class: 'espacio-frame', title: 'Espacio', referrerpolicy: 'no-referrer' }) as HTMLIFrameElement;
    frame.addEventListener('load', () => state.remove(), { once: true });
    frame.src = url;
    el.append(frame);
  }

  void enter().catch(failed);
  return { el, destroy() { abort.abort(); } };
}
